import { Component, OnInit } from "@angular/core"
import { HelpersService } from "src/app/services/helpers.service"
import * as Utils from "../../auth/lib/utils"

@Component({
	selector: "app-pages",
	template: `
		<ng-container *ngIf="canViewPage()">
			<app-navbar *ngIf="isLogged"></app-navbar>
			<router-outlet></router-outlet>
			<app-navbar-bottom *ngIf="isLogged"></app-navbar-bottom>
		</ng-container>
	`
})
export class PagesComponent implements OnInit {
	isLogged = Utils.accessToken
	urlAccessibleNotLogged = ["/report-error", "/marketing/report-error"]

	constructor(private helpersService: HelpersService) {}

	ngOnInit() {
		if (this.isLogged) {
			this.helpersService.setPolling()
		}
	}

	canViewPage() {
		const found = this.urlAccessibleNotLogged.filter(e => e === window.location.pathname)[0]
		if (!this.isLogged && found) {
			return true
		} else if (this.isLogged) {
			return true
		} else {
			return false
		}
	}
}
